export const icon = {
  fullsize: 24,
  padding: 2,
  size: 20,
}
